import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';

function taxFunction() {
	if($(".wp-block-keztablocks-portfolio-taxes").length > 0) {
		$(".wp-block-keztablocks-portfolio-taxes a").each(function() {
			var self = $(this),
			    dataColor = self.parent().attr("data-color"),
			    dataHoverColor = self.parent().attr("data-hcolor"),
			    tl = gsap.timeline({paused:true});

			gsap.set(self,{color:dataColor});

			tl.to(self, {duration: 0.3, color: dataHoverColor});

			self.on("mouseenter", () => {
				tl.play();
			}).on("mouseleave", () => {
				tl.reverse();
			})
		})
	}
}
taxFunction();